module.exports = __webpack_public_path__ + "img/login-bg.24cfbe4d.jpg";